import { Injectable } from '@angular/core';
import { isValidNumber } from '@pineapplelab/util';

@Injectable({
	providedIn: 'root'
})
export class TimerService {

	constructor() { }

	async start(ms: number): Promise<void> {
		return new Promise((resolve, reject) => {
			if (!isValidNumber(ms)) {
				return reject('invalid timer ms');
			}

			setTimeout(resolve, ms);
		});
	}

}
